import { render } from "./input_agreement.vue?vue&type=template&id=4d7a36bc&scoped=true"
import script from "./input_agreement.vue?vue&type=script&lang=js"
export * from "./input_agreement.vue?vue&type=script&lang=js"

import "./input_agreement.vue?vue&type=style&index=0&id=4d7a36bc&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7a36bc"]])

export default __exports__